import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import logo from '~/assets/logo-fatiaprime.png';

const Auth: React.FC = ({ children }) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 1500);
  }, []);

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href={`${process.env.PUBLIC_URL}/assets/css/dashlite.css`}
        />
        <link
          rel="stylesheet"
          href={`${process.env.PUBLIC_URL}/assets/css/custom.css`}
        />
      </Helmet>
      {!show && (
        <div
          style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={logo}
            alt="logo"
            className="ld ld-beat"
            style={{ height: 100, width: 'auto' }}
          />
        </div>
      )}
      {show && (
        <div className="nk-app-root">
          <div className="nk-main ">
            <div className="nk-wrap nk-wrap-nosidebar">
              <div className="nk-content ">
                <div className="nk-split nk-split-page nk-split-md">
                  <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
                    <div className="nk-block nk-block-middle nk-auth-body">
                      <div className="brand-logo pb-2">
                        <img
                          className="logo-img"
                          src={logo}
                          alt="logo"
                          style={{
                            height: 80,
                            width: 'auto',
                            objectFit: 'contain',
                            marginLeft: -9,
                          }}
                        />
                      </div>
                      {children}
                    </div>
                    <div className="nk-block nk-auth-footer">
                      <div className="nk-block-between">
                        <ul className="nav nav-sm">
                          <li className="nav-item">
                            <Link className="nav-link" to="#">
                              {t('index.terms')}
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link className="nav-link" to="#">
                              {t('index.privacy')}
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="mt-3">
                        <p>
                          {`© 2021 ${process.env.REACT_APP_APP_NAME}. Todos os direitos reservados.`}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="nk-split-content nk-split-stretch bg-abstract"
                    style={{
                      position: 'relative',
                      background: 'url(img/auth-image-2.jpg)',
                      backgroundSize: 'cover',
                      transform: 'scaleX(-1)',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Auth;
